module.exports = __webpack_public_path__ + "static/media/Albedo.f95b03a7.png";